module.exports = __webpack_public_path__ + "img/sb1.11d997de.jpg";